// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpCircleFilledSvg from "@fishx/icons-svg/es/asn/UpCircleFilled";
import FishxIcon from '../components/FishxIcon';

var UpCircleFilled = function UpCircleFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleFilledSvg
  }));
};

UpCircleFilled.displayName = 'UpCircleFilled';
export default React.forwardRef(UpCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UpCircleFilled.js
// module id = 4313
// module chunks = 0